module.exports = __webpack_public_path__ + "img/paystack-integration.8c715098.png";